import * as React from 'react'

import { useScene } from '../context/SceneContext'
import { useTimelineData } from '../context/DataContext'
import { ActivityBlock } from '../blocks/ActivityBlock'
import { fillActivityGaps } from '../utils/activityAggregation'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const ActivitiesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const scene = useScene()
  const { activities, selectedActivity, editedActivity, isAddingNew, currentDate } =
    useTimelineData()


  const renderedActivities = React.useMemo(
    () => fillActivityGaps(activities, scene.startTime, scene.days),
    [activities, scene.startTime, scene.days],
  )

  const [leftPosition, setLeftPosition] = React.useState(0)

  const measure = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (node != null) {
        const rect = node.getBoundingClientRect()
        if (rect.left !== leftPosition) {
          setLeftPosition(rect.left)
        }
      }
    },
    [leftPosition],
  )

  return (
    <div ref={measure}>
      <LayerWrapper zIndex={zIndex}>
        {renderedActivities.map((activity, index) => (
          <ActivityBlock
            key={index}
            activity={activity}
            index={index}
            isSelected={
              selectedActivity != null && selectedActivity.id === activity.id
            }
            isEditing={
              editedActivity != null && activity.id === editedActivity.id
            }
            isAddingNew={isAddingNew}
            currentDate={currentDate}
            parentLeftPosition={leftPosition}
          />
        ))}
      </LayerWrapper>
    </div>
  )
}

export default ActivitiesLayer
